<template>
    <div  v-loading="loading" :element-loading-text="formData.i_needsend==1?'招标发布中，系统正在给供应商发送邮件，请等待..':'招标发布中，请等待..'">
        <el-form :model="formData" ref="formRef" label-width="110px" size="mini">
            <div style="color: red;font-size: 16px; font-weight: 700;">{{'请确认发送给供应商的招标文件：'}}</div>
            <el-form-item  label="附件">
                <template v-if="formData.vc_files">
                    <a
                            :download="formData.vc_files.vc_name"
                            mce_href="#"
                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+formData.vc_files.vc_newname+'\'}','utf-8')">
                        {{formData.vc_files.vc_name}}
                    </a>
                </template>
            </el-form-item>
            <div class="flex" v-if="formData.i_needsend==1">
                <el-form-item  label="邮件标题">{{formData.vc_code+'-'+formData.vc_type}}</el-form-item>
<!--                <el-form-item  label="截止时间">{{formData.dt_deadline}}</el-form-item>-->
            </div>
            <el-form-item label="邮件内容" v-if="formData.i_needsend==1">
                <el-input type="textarea"  :rows="3" resize="none"  v-model="formData.vc_content" >
                </el-input>
            </el-form-item>
            <el-form-item label="发送供应商邮箱" v-if="formData.i_needsend==1">
                <ul style="height:200px;overflow-y: auto;max-height: 200px">
                    <li v-for="item in formData.suppliers">{{item.vc_name+'('+item.vc_email+' '+item.vc_lxr+')'}}</li>
                </ul>
            </el-form-item>
            <div style="color: red;font-size: 16px; font-weight: 700;">{{'请确认开标文件接收人：'}}</div>
            <el-form-item  label="接收人" >
                <ul style="height:200px;overflow-y: auto;max-height: 200px">
                    <li v-for="item in formData.uids">{{item.vc_name}}</li>
                </ul>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm('formRef')" :disabled="disabled" :class="baseerp+'btn'" size="small" >确认发布</el-button>
                <!--<el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">编辑</el-button>-->
            </template>
            <el-button @click="cancel" size="small">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                loading:false,
                i_id:0,
                formData:{},
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                canEdit:false,
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data.data) {
                        this.i_id=this.data.data.i_id;
                        this.formData=JSON.parse(JSON.stringify(this.data.data));
                        this.canEdit=true;
                        //console.log(this.formData,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.i_uid= sessionStorage.getItem("userid");
            this.token=sessionStorage.getItem("token");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            editForm(){
                this.canEdit=false
            },
            saveForm(data){
                /*this.$refs[data].validate((valid)=>{
                    if(valid){

                    }else{
                        return false;
                    }
                })*/
                this.savePayment()
            },
            cancel(){
                this.$emit('close')
            },
            async savePayment(){
                this.disabled=true;
                this.loading=true;
                let param={
                    i_id:this.i_id,
                    vc_content:this.formData.vc_content,
                };
                //console.log('param',param)
                let res=await API.publishTender(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                    this.disabled=false;
                    this.loading=false;
                }else{
                    this.$message.error(res.message);
                    this.disabled=false;
                    this.loading=false;
                }
            },

        },
    }
</script>

<style lang="scss" scoped>
    /deep/.number .el-input__inner{
        text-align: left !important;
    }
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-around;

    }
    .changeinput{
        width: 200px;
        display: inline-block;
    }
</style>